export default "__VITE_ASSET__Dpji226K__"